import * as React from 'react';
import './SearchResultsView.scss';
import ModelsPartsResults from './../../components/ModelsPartsResults';
import { withRouter } from 'react-router-dom';

interface ISearchResultsViewProps {
  onSetSearchText: (text: string) => void;
  match: any;
  history: any;
}

export class SearchResultsView extends React.Component<
  ISearchResultsViewProps,
  any
> {
  private unlisten: any;
  public componentDidMount = () => {
    let isBackButtonClicked=false;
    this.unlisten = this.props.history.listen((location: any, action:any) => {
      if (action === 'POP') {
        isBackButtonClicked=true;
         const searchQuery = decodeURIComponent(this.props.match.params.text);
          if (searchQuery != null) {
            this.props.onSetSearchText(searchQuery);
          }
      }
    });
    if(isBackButtonClicked===false){
      const searchQuery = decodeURIComponent(this.props.match.params.text);
      if (searchQuery != null) {
        this.props.onSetSearchText(searchQuery);
      }
    }
  };
  public componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }
  public render() {
    return (
      <div className="rp-search-results-view">
        <ModelsPartsResults />
      </div>
    );
  }
}
